import React, { useEffect } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'

import CustomCard from '../../utils/components/CustomCard';
import { Box, Divider, Typography, Grid, Container, Button } from '@mui/material';

function IndexAlmacen() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    useEffect(() => {
        if (!['Admin', 'Almacen'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Almacenes';
    }, [auth])

    return (
        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Almacenes</Typography>
            </Box>
            <Button size='small' variant='outlined' onClick={() => navigate('/dashboard')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Divider variant="middle" className='my-3' />
            <Grid container spacing={3}>
                {cards.map((card, i) => (
                    <Grid item key={i} xs={12} sm={6} md={4}>
                        <CustomCard
                            title={card.title}
                            to={card.to}
                            button={card.button}
                            cardIco={card.cardIco}
                            text={card.text}
                            color={'primary.main'}
                            btnColor={'primary'}
                        />
                    </Grid>
                ))}
            </Grid>
            <br></br>
        </Container>
    )
}

const cards = [
    {
        title: "Ver Almacenes",
        text: "Ver todos los almacenes creados.",
        button: "Almacenes",
        cardIco: "fad fa-warehouse fa-3x",
        to: "/almacenes/verAlmacenes"
    },
    {
        title: "Crear Almacén",
        text: "Crear un nuevo almacén.",
        button: "Crear Almacén",
        cardIco: "fad fa-plus fa-3x",
        to: "/almacenes/nuevoAlmacen"
    },
]

export default IndexAlmacen;